export default {
  default: ({item, track, line, blockcode}) => item.kurs == track,
  lvb: ({item, track, line, blockcode}) => item.kurs == track,
  dsw21: ({item, track, line, blockcode, tourHash}) => {
    if (tourHash) {
      return item.tourHash === tourHash;
    }
    if (blockcode) {
      return item.title === blockcode && item.linien && item.linien.split(',').includes(line);
    }
    return item.linien && item.linien.split(',').includes(line);
  },
  cvag: ({item, track, line, blockcode}) => {
    if (line && blockcode){
      let cvagKurs=`${line.padStart(2,'0')}${blockcode.padStart(2,'0')}`

      if (item.kurs ==cvagKurs ){
        return true;
      }
    }


    if (track) {
      return item.kurs == track
    }

  }
};
